<ion-header style="border: 1px solid var(--ion-color-step-100)">
  <div class="modal-header">
    <ion-toolbar>
      <div class="modal-title">
        <h3>Create slack user group</h3>
      </div>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>

  <div style="padding: 0 15px 15px">
    <div>
      <ion-label class="input-label">
        Name <span class="required-indicator">*</span>
      </ion-label>
      <ion-input
        #nameInput
        type="text"
        placeholder="User group name"
        [(ngModel)]="name"
        [maxlength]="MAX_LENGTH"
        class="input-field"
      ></ion-input>
    </div>

    <div>
      <ion-label class="input-label">
        Slack handle <span class="required-indicator">*</span>
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            placement: 'top'
          }"
          data-tippy-content="The Slack handle should be a unique lowercase handle and contain only letters, numbers, hyphens, and underscores. The maximum length is 80 characters."
        ></ion-icon>
      </ion-label>
      <ion-input
        #handleInput
        type="text"
        placeholder="user-group-123"
        [(ngModel)]="handle"
        [maxlength]="MAX_LENGTH"
        class="input-field"
      ></ion-input>
    </div>

    <div>
      <ion-label class="input-label">
        Description
        <span class="optional-indicator">(optional)</span>
      </ion-label>
      <ion-textarea
        #descriptionInput
        lines="3"
        autoGrow="true"
        placeholder="e.g. On-call team that handles escalated tickets"
        [(ngModel)]="description"
        class="input-field"
      ></ion-textarea>
    </div>

    <div *ngIf="connectedTeams?.length > 1">
      <ion-label class="input-label">Slack Workspace</ion-label>
      <ion-select
        [(ngModel)]="selectedTeam"
        class="input-field"
        interface="popover"
        placeholder="Select Slack Workspace"
        [compareWith]="compareTeams"
      >
        <ion-select-option *ngFor="let team of connectedTeams" [value]="team">
          {{ team.name }}
        </ion-select-option></ion-select
      >
    </div>

    <ion-button
      [disabled]="isLoading || !canSubmit()"
      (click)="submit()"
      size="block"
      style="margin: 10px 0 0 0"
    >
      {{ !userGroupId ? "Please save the user group first." : "Sync to Slack" }}
      <ion-spinner
        name="crescent"
        [hidden]="!isLoading"
        class="submit-spinner"
      ></ion-spinner>
    </ion-button>
  </div>
</ion-header>
